import React from 'react'
import PropTypes from 'prop-types'

import StatsNumber from '../StatsNumber'

function ModelsTooltip({ value = 0 }) {
  return (
    <div>
      <StatsNumber
        value={value}
        title="This number indicates how many models you should improve in terms of presentation"
        format="0"
        textColor="is-negative"
      />
      {value > 0
      && <a href="/profile/analytics/improvements" target="_blank" className="btn btn-primary btn-block">Improve now</a>
      }
    </div>
  )
}

ModelsTooltip.propTypes = {
  value: PropTypes.number,
}

export default ModelsTooltip
